var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToFirstPageIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.833 10H9.5m3.333-4.167L9.256 9.411a.833.833 0 000 1.178l3.577 3.578M5.822 5.833L2.244 9.411a.833.833 0 000 1.178l3.578 3.578",
    stroke: "#171E37",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToFirstPageIcon);
export default __webpack_public_path__ + "static/media/to_first_page_icon.431d06fdc47db6ab183ab6f65001e7d9.svg";
export { ForwardRef as ReactComponent };